import { FC } from 'react'

import { GreyGrey60, IconUser } from '@sequencehq/core-components'

import { useManualTask } from 'Automations/watchtower/inbox/manualTasks/hooks/useManualTask'
import { TaskInput } from './types'
import { getGenericNotificationTitle } from './getGenericNotificationTitle'
import { useCustomerData } from '../../hooks/useCustomerData'
import { NotificationHeader } from '../../components/NotificationHeader'

export const GenericNotificationHeader: FC<{
  taskId: string
}> = ({ taskId }) => {
  const { manualTask } = useManualTask({ taskId })
  const input = manualTask?.input as TaskInput | undefined
  const { customer, isPending: isCustomerPending } = useCustomerData(
    input?.customerId
  )

  // Gate on the customer query the same way the list item and preview do, so the
  // title doesn't first render un-prefixed with the fallback icon and then flip
  // to "{customer}: {title}" with the logo once the query resolves.
  if (!input || isCustomerPending) {
    return null
  }

  return (
    <NotificationHeader
      data-testid="watchtower.notification.genericNotification.header"
      customer={customer}
      fallbackIcon={<IconUser color={GreyGrey60} />}
      title={getGenericNotificationTitle(input.title, customer?.legalName)}
    />
  )
}
